// Event bus for signaling movement away from Home and need for killing scrollTriggers

import Vue from "vue";
export const EventBus = new Vue();
